module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/2BTasNV5uA4sq4uuEC4II6-5fa92b3f512ada79861aec9aac41b958.jpg";